import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import numeral from 'numeral'
import './vee-validate'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import JQuery from 'jquery'
import sweetalert from 'sweetalert2'
import { VueMaskDirective } from 'v-mask'
import globalMixin from './mixins/global'

// import VConsole from 'vconsole'
// new VConsole()

Vue.directive('mask', VueMaskDirective)

Vue.filter('numberFormat', function (value) {
  return numeral(value).format('0,0.00')
})
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.directive('uppercase', {
  inserted: function (el, _, vnode) {
    el.addEventListener('input', async function (e) {
      e.target.value = e.target.value.toUpperCase()
      vnode.componentInstance.$emit('input', e.target.value.toUpperCase())
    })
  }
})

Vue.mixin(globalMixin)

Vue.prototype.$liff = window.liff
Vue.prototype.$swal = sweetalert
window.$ = JQuery

Vue.config.productionTip = false

Vue.config.errorHandler = function (err, vm, info) {
  console.error('GLOBAL ERROR:', err)

  const traceId = Date.now()
  const message =
    err?.message || err?.response?.data?.message || err?.statusMessage || JSON.stringify(err)

  const payload = {
    title: 'เกิดข้อผิดพลาด',
    text: message,
    html: `กรุณาติดต่อเจ้าหน้าที่ <small>(Trace ID: ${traceId})</small><br/>${info}<br/>${message}`
  }
  if (vm && vm.$swal) {
    vm.$swal.fire({
      icon: 'error',
      ...payload
    })
  } else {
    alert('Error: Main Global ' + JSON.stringify(payload))
  }
}

new Vue({
  router,
  store,
  vuetify,
  created() {
    return (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0]
      if (d.getElementById(id)) {
        return
      }
      js = d.createElement(s)
      js.id = id
      js.src = '//connect.facebook.com/en_US/messenger.Extensions.js'
      fjs.parentNode.insertBefore(js, fjs)
    })(document, 'script', 'Messenger')
  },
  render: (h) => h(App)
}).$mount('#app')
